import { useState } from 'react';

const PrintContentPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showPrintContentPopup, setShowPrintContentPopup] =
      useState<boolean>(false);

    const printToggleHandler = () => {
      setShowPrintContentPopup(!showPrintContentPopup);
    };

    return (
      <Component
        showPrintContentPopup={showPrintContentPopup}
        printToggleHandler={printToggleHandler}
        {...props}
      />
    );
  };

export default PrintContentPopupHOC;
